<template>
    <div>

        <!-- /*------  Modals  ------*/ -->
        <!-- /*--- Modal 1 ---*/ -->
        <div class="modal fade" id="Modal-form-1" tabindex="-1" role="dialog" aria-labelledby="Modal-form-1-Label" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content border-0" :class="{componentLoading: this.loading}">

                    <div class="modal-header flex-column align-items-center border-0" ref="scrollhere">
                        <h2 class="s7_underlink modal-title position-relative font-weight-bold text-center text-uppercase" id="Modal-form-1-Label" v-html="translations.rezervaceCesty"></h2>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <p class="s7_modal-header-text text-center">{{translations.provedteRezervaci}}</p>
                    </div>



                    <!-- PART 1 -->
                    <div class="modal-body" v-show="step == 0">
                        <div class="s7_modal-body-content s7_modal-body-content-start-1">
                            <h3 class="font-weight-bold"><i class="fas fa-map-marker-alt"></i>{{translations.vyzvednemeVas}}</h3>
                            <div class="form-field" :class="{ 'form-field--error': $v.step_first.data_destination_from.$error }">
                                <label for="s7_input-form-start" class="s7_modal-body-undertext text-uppercase">{{translations.adresa}} * <span class="s7_modal-body-lower-text">({{translations.priZmeneAdresy}})</span></label>
                                <input ref="fromInput" type="text" id="s7_input-form-start" class="border-0 w-100" v-model.trim="$v.step_first.data_destination_from.$model" autocomplete="off">

                                <div class="form-field-error" v-if="!$v.step_first.data_destination_from.required">{{translations.poleJePovinne}}</div>
                                <div class="form-field-error" v-if="!$v.step_first.data_destination_from.minLength">{{translations.poleMusiMit}}</div>
                            </div>
                        </div>
                        <div class="s7_modal-body-content s7_modal-body-content-end-1">
                            <h3 class="font-weight-bold"><i class="fas fa-map-marker-alt"></i>{{translations.odvezemeVas}}</h3>
                            <div class="form-field" :class="{ 'form-field--error': $v.step_first.data_destination_to.$error }">
                                <label for="s7_input-form-goal" class="s7_modal-body-undertext text-uppercase">{{translations.adresa}} * <span class="s7_modal-body-lower-text">({{translations.priZmeneAdresy}})</span></label>
                                <input ref="toInput" type="text" id="s7_input-form-goal" class="border-0 w-100" v-model.trim="$v.step_first.data_destination_to.$model" autocomplete="off">
                                <div class="form-field-error" v-if="!$v.step_first.data_destination_to.required">{{translations.poleJePovinne}}</div>
                                <div class="form-field-error" v-if="!$v.step_first.data_destination_to.minLength">{{translations.poleMusiMit}}</div>
                            </div>
                        </div>

                    </div>

                    
                    <!-- PART 2 -->
                    <div class="modal-body" v-if="step == 1">
                        <div class="s7_modal-body-content s7_modal-body-content-start-2">
                            <h3 class="font-weight-bold"><i class="far fa-clock"></i>{{translations.kdyProVasPrijedeme}}</h3>
                            <div class="form-field" :class="{ 'form-field--error': $v.step_second.time_date.$error }">
                                <label for="s7_input-form-date" class="s7_modal-body-undertext text-uppercase">{{translations.datumACas}} * <span class="s7_modal-body-lower-text">{{translations.zadejteKdyAVKolik}}</span></label>
                                <input type="datetime-local" value="2020-06-22T19:30" name="s7_input-form-date" class="border-0 w-100" v-model.trim="$v.step_second.time_date.$model">
                                <div class="form-field-error" v-if="!$v.step_second.time_date.required">{{translations.poleJePovinne}}</div>
                            </div>
                        </div>
                        <div class="s7_modal-body-content s7_modal-body-content-mid-2" :class="{'disabled': !selected_way_option}">
                            <h3 class="font-weight-bold"><i class="far fa-clock"></i>{{translations.kdyProVasPrijedeme}} {{translations.cestaZpet}}</h3>
                            <div class="form-field" :class="{ 'form-field--error': $v.step_second.time_date_two_way.$error }">
                                <label for="s7_input-form-goal-date" class="s7_modal-body-undertext text-uppercase">{{translations.datumACas}} * <span class="s7_modal-body-lower-text">{{translations.zadejteKdyAVKolikCestaZpet}}</span></label>
                                <input type="datetime-local" value="2020-06-22T19:30" name="s7_input-form-goal-date" v-model.trim="$v.step_second.time_date_two_way.$model" class="border-0 w-100" :disabled="!selected_way_option">
                                <div class="form-field-error" v-if="!$v.step_second.time_date_two_way.required">{{translations.poleJePovinne}}</div>
                            </div>
                        </div>
                        <div class="s7_modal-body-content s7_modal-body-content-end-2 position-relative">
                            <h3 class="font-weight-bold"><i class="fas fa-male"></i>{{translations.pocetOsob}}</h3>
                            <div class="form-field" :class="{ 'form-field--error': $v.step_second.persons.$error }">
                                <label for="s7_input-form-count-passenger" class="s7_modal-body-undertext text-uppercase">{{translations.pocetOsob}} * <span class="s7_modal-body-lower-text">{{translations.kolikOsobChcete}}</span></label>
                                <input type="number" name="s7_input-form-count-passenger" class="border-0 w-100" v-model.trim="$v.step_second.persons.$model" @change="checkForNewPrice">
                                <div class="s7_buttons-p-m position-absolute d-flex flex-column justify-content-between">
                                    <span class="s7_button-plus-minus d-flex align-items-center p-0 justify-content-center border-0 text-white minus" @click="decreasePersons()">-</span>
                                    <span class="s7_button-plus-minus d-flex align-items-center p-0 justify-content-center border-0 text-white plus" @click="increasePersons()">+</span>
                                </div>
                                <div class="form-field-error" v-if="!$v.step_second.persons.required">{{translations.poleJePovinne}}</div>
                            </div>
                        </div>

                    </div>


                    <!-- PART 3 -->
                    <div class="modal-body" v-if="step == 2">
                        <div class="s7_modal-body-content s7_modal-body-content-start-3">
                            <h3 class="font-weight-bold"><i class="fas fa-user-alt"></i>{{translations.vaseUdaje}}</h3>
                            <div class="s7_input-personal-info-row row">
                                <div class="col-md-6 col-12">
                                    <div class="form-field" :class="{ 'form-field--error': $v.step_third.name.$error }">
                                        <label for="s7_input-form-first-name" class="s7_modal-body-undertext text-uppercase">{{translations.jmeno}} *</label>
                                        <input type="text" name="s7_input-form-first-name" class="border-0 w-100" :placeholder="translations.jan" v-model.trim="$v.step_third.name.$model">
                                        <div class="form-field-error" v-if="!$v.step_third.name.required">{{translations.poleJePovinne}}</div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-12">
                                    <div class="form-field" :class="{ 'form-field--error': $v.step_third.surename.$error }" >
                                        <label for="s7_input-form-last-name" class="s7_modal-body-undertext text-uppercase">{{translations.prijmeni}} *</label>
                                        <input type="text" name="s7_input-form-last-name" class="border-0 w-100" :placeholder="translations.novak" v-model.trim="$v.step_third.surename.$model">
                                        <div class="form-field-error" v-if="!$v.step_third.surename.required">{{translations.poleJePovinne}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="s7_input-personal-info-row row">
                                <div class="col-md-6 col-12">
                                    <div class="form-field" :class="{ 'form-field--error': $v.step_third.email.$error }">
                                        <label for="s7_input-form-email" class="s7_modal-body-undertext text-uppercase">{{translations.email}} *</label>
                                        <input type="email" name="s7_input-form-email" class="border-0 w-100" :placeholder="translations.mail" v-model.trim="$v.step_third.email.$model">
                                        <div class="form-field-error" v-if="!$v.step_third.email.required">{{translations.poleJePovinne}}</div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-12">
                                    <div class="form-field" :class="{ 'form-field--error': $v.step_third.telephone.$error }">
                                        <label for="s7_input-form-tel" class="s7_modal-body-undertext text-uppercase">{{translations.telefon}} *</label>
                                        <input type="tel" name="s7_input-form-tel" class="border-0 w-100" :placeholder="translations.phone" v-model.trim="$v.step_third.telephone.$model" @blur="normalizeTelephoneInput">
                                        <div class="form-field-error" v-if="!$v.step_third.telephone.required">{{translations.poleJePovinne}}</div>
                                        <div class="form-field-error" v-if="$v.step_third.telephone.required && !$v.step_third.telephone.phoneFormat">{{translations.telefonNeniValidni}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="s7_input-personal-info-row row">
                                <div class="col-md-6 col-12">
                                    <div class="form-field">
                                        <label for="s7_input-form-sign" class="s7_modal-body-undertext text-uppercase">{{translations.pickupSign}}</label>
                                        <input type="text" name="s7_input-form-sign" class="border-0 w-100" :placeholder="translations.jannovak" v-model="step_third.pickupsign">
                                    </div>
                                </div>
                                <div class="col-md-6 col-12">
                                    <div class="form-field">
                                        <label for="s7_input-form-travel" class="s7_modal-body-undertext text-uppercase">{{translations.cisloLetu}}</label>
                                        <input type="text" name="s7_input-form-travel" class="border-0 w-100" :placeholder="translations.cx" v-model="step_third.transport_id">
                                    </div>
                                </div>
                            </div>
                            <label for="s7_input-form-note" class="s7_modal-body-undertext text-uppercase">{{translations.poznamka}}</label>
                            <input type="text" name="s7_input-form-note" class="s7_input-form-note border-0 w-100" :placeholder="translations.privezteMiNeco" v-model="step_third.note">
                            <h3 class="s7_custom-checkboxes-title font-weight-bold"><i class="fas fa-star"></i>{{translations.specialniPozadavky}}</h3>
                            <div class="s7_form-special-checkboxes form-check p-0 d-flex">
                                <label class="container">{{translations.velkaZavazadla}}
                                    <input type="checkbox" v-model="step_third.large_baggage">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="container">{{translations.detskaSedacka}}
                                    <input type="checkbox" v-model="step_third.kid_seat">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <p>
                                <strong>{{translations.vekAVaha}}</strong>
                            </p>
                        </div>

                    </div>


                    <!-- PART 4 -->
                    <div class="modal-body pt-0" v-if="step == 3">
                        <div class="s7_modal-body-content s7_modal-body-content-start-4">
                            <h3 class="font-weight-bold"><i class="fas fa-map-marker-alt"></i>{{translations.rekapitulace}}</h3>
                            <div class="s7_content-ico-row s7_recap-dates-times d-flex align-items-baseline">
                                <i class="s7_content-ico far fa-calendar-alt"></i>
                                <p class="s7_recap-date-time-start mb-0">{{step_second.time_date | format_date}}</p>
                                <i class="s7_content-ico fas fa-history" v-if="selected_way_option == true"></i>
                                <p class="s7_recap-date-time-goal mb-0" v-if="selected_way_option == true">{{step_second.time_date_two_way | format_date}}</p>
                            </div>
                            <div class="s7_content-ico-row s7_recap-persons d-flex align-items-baseline">
                                <i class="s7_content-ico fas fa-user-alt"></i>
                                <p class="s7_recap-name mb-0">{{step_third.name}} {{step_third.surename}}</p>
                                <p class="s7_recap-count mb-0"> ({{step_second.persons}} {{translations.osoby}})</p>
                            </div>
                            <div class="s7_content-ico-row s7_recap-start-goal d-flex align-items-baseline mb-0">
                                <i class="s7_content-ico fas fa-map-marker-alt"></i>
                                <p class="s7_recap-start mb-0">{{step_first.data_destination_from}}</p>
                                <i class="s7_content-ico fas fa-long-arrow-alt-right"></i>
                                <p class="s7_recap-goal mb-0">{{step_first.data_destination_to}}</p>
                            </div>
                        </div>
                        <div class="s7_modal-body-content s7_modal-body-content-mid-4">
                            <h3 class="font-weight-bold">
                                <i class="fas fa-map-marker-alt"></i>
                                <span v-html="translations.jakZaplatite"></span>
                                <span class="s7_payment-title">({{data_final_price | format_price}} {{currency_label}})</span>
                            </h3>
                            <div class="s7_chose-payment-method">
                                <label for="s7_payment-methods" class="s7_modal-body-undertext text-uppercase">{{translations.vybertePlatebniMetodu}}</label>
                                <select name="s7_payment-methods" id="methods" class="border-0 w-100" v-model="step_fourth.payment">
                                    <option value="2">{{translations.platbaKartouRidici}}</option>
                                    <option value="1">{{translations.platbaKartou}}</option>
                                    <option value="0">{{translations.platbaHotoveVCili}}</option>
                                </select>
                            </div>
                        </div>
                        <p class="s7_form-4-text-links text-center" v-html="translations.pokracovanimSouhlasiteS"></p>
                    </div>

                    <div class="modal-body">

                        <div class="s7_form-next-btn-div">
                            <div @click.prevent="nextStep" class="s7_form-next-btn btn mx-auto border-0 rounded-0 font-weight-bold d-flex justify-content-between align-items-center w-100">
                                <span class="text-white text-uppercase">{{translations.pokracovat}}</span>
                                <i class="fas fa-chevron-right text-white"></i>
                            </div>
                        </div>

                        <div class="s7_form-1-end row flex-sm-row flex-column">
                            <div class="col-md-4 col-sm-6 col-12 d-flex align-items-center justify-content-center mb-md-0 mb-4">
                                <figure class="mb-0">
                                    <img :src="this.images_path + '/Form-way.png'" alt="">
                                </figure>
                                <p class="s7_form-1-end-big-text font-weight-bold mb-0">{{data_distance}} <span class="font-weight-light">Km</span></p>
                            </div>
                            <div class="col-md-4 col-sm-6 col-12 d-flex align-items-center justify-content-center mb-md-0 mb-4">
                                <figure class="mb-0">
                                    <img :src="this.images_path + '/Form-time.png'" alt="">
                                </figure>
                                <p class="s7_form-1-end-big-text font-weight-bold mb-0">{{Math.round(data_duration/1000/60/60*100)/100}} <span class="font-weight-light">h</span></p>
                            </div>
                            <div class="col-md-4 col-sm-6 col-12 d-flex align-items-center justify-content-center mb-md-0 mb-4">
                                <figure class="mb-0">
                                    <img :src="this.images_path + '/Form-cash.png'" alt="">
                                </figure>
                                <p class="s7_form-1-end-big-text font-weight-bold mb-0">{{data_final_price | format_price}} <span class="font-weight-light">{{currency_label}}</span></p>
                            </div>
                        </div>

                    </div>

                    <div class="modal-footer border-0 d-flex flex-wrap justify-content-between">
                        <p class="s7_modal-footer-text text-white m-0" :class="{'s7_modal-footer-text-filled': step>=0}" @click="setStep(0)">1. {{translations.misto}}</p>
                        <p class="s7_modal-footer-text text-white m-0" :class="{'s7_modal-footer-text-filled': step>=1}" @click="setStep(1)">2. {{translations.osobyADatum}}</p>
                        <p class="s7_modal-footer-text text-white m-0" :class="{'s7_modal-footer-text-filled': step>=2}" @click="setStep(2)">3. {{translations.udajeObjednatele}}</p>
                        <p class="s7_modal-footer-text text-white m-0" :class="{'s7_modal-footer-text-filled': step>=3}" @click="setStep(3)">4. {{translations.platba}}</p>
                        <p class="s7_modal-footer-text text-white m-0">5. {{translations.potvrzeni}}</p>
                    </div>

                    <form :action="home_url + '/objednavka/'" method="post" class="fakeForm">
                        <input type="hidden" name="action" value="createNewOrder">

                        <input type="hidden" :name="'db_' + index" :value="field" v-for="(field,index) in form_data">
                        <button ref="formSubmit" name="submit" value="1" type="submit"></button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { required, minLength, email, integer, requiredIf } from 'vuelidate/lib/validators';
    import Axios from "axios";
    import VueAxios from 'vue-axios';

    const phoneFormat = (value) => {
        if (!value) {
            return true;
        }
        let digits = value.replace(/\D/g, '').replace(/^0+/, '');
        if (digits.length === 12 && digits.indexOf('420') === 0) {
            digits = digits.slice(3);
        }
        return digits.length === 9 && /^[1-9]/.test(digits);
    };

    export default {
        name: "ReservationForms",
        components: {},
        props: {
            destination_from : {
                required: true,
                type: String
            },
            destination_from_lat_lng: {
                required: true,
                type: Object
            },
            destination_to : {
                required: true,
                type: String
            },
            destination_to_lat_lng: {
                required: true,
                type: Object
            },
            distance: {
                required: true,
                type: Number
            },
            duration: {
                required: true,
                type: Number
            },
            currency: {
                required: true,
                type: Number
            },
            selected_offer: {
                required: true,
                type: Object | Boolean
            },
            selected_way_option: {
                required: true,
                type: Number | Boolean
            },
            precalculated_price: {
                required: true,
                type: Number
            },
            images_path: {
                required: true,
                type: String
            },
            api_url: {
                required: true,
                type: String
            },
            home_url: {
                required: true,
                type: String
            },
            translations: {
                required: true,
                type: String
            }
        },
        data: function () {
            return {
                step: 0,
                data_destination_from_lat_lng: false,
                data_destination_to_lat_lng: false,
                data_distance: 0,
                data_duration: 0,
                data_final_price: 0,
                data_currency: 0,
                step_first: {
                    data_destination_from: "",
                    data_destination_to: "",
                },
                step_second: {
                    time_date: "",
                    time_date_two_way: "",
                    persons: 1,
                },
                step_third: {
                    name: "",
                    surename: "",
                    email: "",
                    telephone: "",
                    pickupsign: "",
                    transport_id: "",
                    note: "",
                    kid_seat: false,
                    large_baggage: false,
                },
                step_fourth: {
                    payment: 1
                },
                loading: false,
                places: [],

            }
        },
        validations: {
            step_first: {
                data_destination_from: {
                    required,
                    minLength: minLength(3)
                },
                data_destination_to: {
                    required,
                    minLength: minLength(3)
                }
            },
            step_second: {
                time_date: {
                    required
                },
                time_date_two_way: {
                    requiredIf: requiredIf(function(){
                        return this.selected_way_option === true;
                    })
                },
                persons: {
                    required
                }
            },
            step_third: {
                name: {
                    required,
                    minLength: minLength(3)
                },
                surename: {
                    required,
                    minLength: minLength(3)
                },
                email: {
                    required,
                    email
                },
                telephone: {
                    required,
                    phoneFormat
                }
            },
        },
        mounted: function () {
            var _this = this;
            var modal = document.getElementById('Modal-form-1');

            if (modal && window.jQuery) {
                jQuery(modal).on('shown.bs.modal', function () {
                    _this.onModalShown();
                });
            }

            this.onGoogleMapsReady = function () {
                var el = document.getElementById('Modal-form-1');
                if (el && el.classList.contains('show')) {
                    _this.bindPlaces();
                }
            };
            this.$root.$on('googleMapsInitialized', this.onGoogleMapsReady);
        },
        beforeDestroy: function () {
            var modal = document.getElementById('Modal-form-1');

            if (modal && window.jQuery) {
                jQuery(modal).off('shown.bs.modal');
            }

            if (this.onGoogleMapsReady) {
                this.$root.$off('googleMapsInitialized', this.onGoogleMapsReady);
            }

            this.unbindPlaces();
        },
        methods: {

            onModalShown: function () {
                this.bindPlaces();
            },

            open: function (data) {
                this.loading = false;
                this.step = 0;
                this.step_first.data_destination_from = data.destination_from;
                this.step_first.data_destination_to = data.destination_to;
                this.data_destination_from_lat_lng = data.from_lat_lng;
                this.data_destination_to_lat_lng = data.to_lat_lng;
                this.data_distance = data.distance;
                this.data_duration = data.duration;
                this.data_currency = data.currency;
                this.data_final_price = data.price;
                this.checkForNewPrice();
            },

            isLatLng: function (point) {
                if (!point || typeof point !== 'object' || Array.isArray(point)) {
                    return false;
                }
                return point.lat != null && point.lng != null
                    && !isNaN(Number(point.lat)) && !isNaN(Number(point.lng));
            },

            routePoint: function (latLng, address) {
                if (this.isLatLng(latLng)) {
                    return {
                        lat: Number(latLng.lat),
                        lng: Number(latLng.lng)
                    };
                }
                if (address && String(address).trim().length >= 3) {
                    return String(address).trim();
                }
                return null;
            },

            bindPlaces: function () {
                if (!window.google || !google.maps || !google.maps.places) {
                    return;
                }
                this.bindPlace(this.$refs.fromInput, 'from');
                this.bindPlace(this.$refs.toInput, 'to');
            },

            bindPlace: function (input, field) {
                var element = input && input.$el ? input.$el : input;

                if (!element || element._placeBound) {
                    return;
                }

                var _this = this;
                var autocomplete = new google.maps.places.Autocomplete(element, {
                    fields: ['formatted_address', 'geometry']
                });

                autocomplete.addListener('place_changed', function () {
                    _this.onPlaceSelected(field, autocomplete);
                });

                element._placeBound = true;
                this.places.push(autocomplete);
            },

            unbindPlaces: function () {
                if (window.google && google.maps && this.places.length) {
                    this.places.forEach(function (autocomplete) {
                        google.maps.event.clearInstanceListeners(autocomplete);
                    });
                }
                this.places = [];

                if (this.$refs.fromInput) {
                    var fromEl = this.$refs.fromInput.$el || this.$refs.fromInput;
                    fromEl._placeBound = false;
                }
                if (this.$refs.toInput) {
                    var toEl = this.$refs.toInput.$el || this.$refs.toInput;
                    toEl._placeBound = false;
                }
            },

            onPlaceSelected: function (field, autocomplete) {
                var place = autocomplete.getPlace();
                if (!place || !place.geometry || !place.geometry.location) {
                    return;
                }

                var latLng = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                };
                var input = field === 'from' ? this.$refs.fromInput : this.$refs.toInput;
                var address = place.formatted_address || (input ? input.value : '');

                if (field === 'from') {
                    this.step_first.data_destination_from = address;
                    this.data_destination_from_lat_lng = latLng;
                } else {
                    this.step_first.data_destination_to = address;
                    this.data_destination_to_lat_lng = latLng;
                }

                this.updateRoute();
            },

            updateRoute: function () {
                var _this = this;
                var origin = this.routePoint(
                    this.data_destination_from_lat_lng,
                    this.step_first.data_destination_from
                );
                var destination = this.routePoint(
                    this.data_destination_to_lat_lng,
                    this.step_first.data_destination_to
                );

                if (!origin || !destination) {
                    this.loading = false;
                    return;
                }

                this.loading = true;
                var directionsService = new google.maps.DirectionsService();

                directionsService.route({
                    origin: origin,
                    destination: destination,
                    travelMode: google.maps.TravelMode.DRIVING
                }, function (response, status) {
                    if (status !== 'OK' || !response.routes || !response.routes.length) {
                        _this.loading = false;
                        return;
                    }

                    var leg = response.routes[0].legs[0];
                    _this.data_distance = Math.ceil(leg.distance.value / 1000);
                    _this.data_duration = leg.duration.value * 1000;
                    _this.data_destination_from_lat_lng = {
                        lat: leg.start_location.lat(),
                        lng: leg.start_location.lng()
                    };
                    _this.data_destination_to_lat_lng = {
                        lat: leg.end_location.lat(),
                        lng: leg.end_location.lng()
                    };
                    _this.checkForNewPrice();
                });
            },

            normalizeTelephoneInput: function () {
                if (!this.step_third.telephone) {
                    return;
                }
                let digits = this.step_third.telephone.replace(/\D/g, '').replace(/^0+/, '');
                if (digits.length === 12 && digits.indexOf('420') === 0) {
                    digits = digits.slice(3);
                }
                if (digits.length === 9) {
                    this.step_third.telephone = digits.slice(0, 3) + ' ' + digits.slice(3, 6) + ' ' + digits.slice(6, 9);
                }
            },

            increasePersons: function(){
                this.step_second.persons++;
                this.checkForNewPrice();
            },
            decreasePersons: function(){
                if(this.step_second.persons > 1){
                    this.step_second.persons--;
                    this.checkForNewPrice();
                }
            },

            nextStep: function () {
                if (this.step === 2) {
                    this.normalizeTelephoneInput();
                }
                var toValidate = null;
                switch (this.step) {
                    case 0: toValidate = this.$v.step_first;break;
                    case 1: toValidate = this.$v.step_second;break;
                    case 2: toValidate = this.$v.step_third;break;
                    case 3: toValidate = true;break;
                }
                if(toValidate === true){
                    this.$refs['formSubmit'].click();
                    return true;
                }

                toValidate.$touch();
                if (!toValidate.$invalid) {

                    var options = {
                        container: '.modal',
                        easing: 'ease-in',
                        offset: 0,
                        force: true,
                        cancelable: true,
                        x: false,
                        y: true
                    };
                    var element = this.$refs['scrollhere'];
                    this.$scrollTo(element,300, options);

                    this.step++;
                }
            },
            setStep: function(step){
                if(this.step > step){
                    this.step = step;
                }
            },
            checkForNewPrice: function () {

                this.loading = true;
                var request = {
                    persons: this.step_second.persons,
                    destination_from: this.step_first.data_destination_from,
                    destination_to: this.step_first.data_destination_to,
                    from_lat_lng: this.data_destination_from_lat_lng,
                    to_lat_lng: this.data_destination_to_lat_lng,
                    selected_offer: this.selected_offer,
                    duration: this.data_duration,
                    distance: this.data_distance,
                    selected_way_option: this.selected_way_option,
                    currency: this.data_currency
                };

                var _this = this;
                var finalurl = _this.api_url + "?action=checkCarPrice";

                Axios.post(finalurl, request).then(function (response) {
                    if (response){
                        if(typeof response.data == "object"){
                            if(response.data.status == 1){
                                if(response.data.payload && response.data.payload.final_price != null){
                                    _this.data_final_price = response.data.payload.final_price;
                                }
                            }else if(response.data.status == -1){
                                _this.decreasePersons();
                                alert(response.data.message);
                            }
                        }else{
                            console.error("Data is not type of Object");
                        }
                    }
                    _this.loading = false;
                }).catch(function (error) {
                    console.error(error);
                    _this.loading = false;
                });
            }
        },
        filters: {
            format_price: function (price) {
                let val = price;
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            },
            format_date: function (date) {
                var options = {
                    year: 'numeric', month: 'numeric', day: 'numeric',
                    hour: 'numeric', minute: 'numeric'
                };
                return new Intl.DateTimeFormat('cs-CZ', options).format(new Date(date));
            }
        },
        computed: {
            data_destination_from: function () {
                return this.step_first.data_destination_from;
            },
            data_destination_to: function () {
                return this.step_first.data_destination_to;
            },
            persons: function () {
                return this.step_second.persons;
            },
            currency_label: function () {
                return (this.data_currency == 1 ? "€" : "Kč");
            },
            form_data: function () {
                let result = {
                    ...this.step_first,
                    ...this.step_second,
                    ...this.step_third,
                    ...this.step_fourth,
                    'final_price' : this.data_final_price,
                    'currency' : (this.data_currency === 1 || this.data_currency === '1' || this.data_currency === true) ? '1' : '0',
                    'kid_seat' : this.step_third.kid_seat ? 1 : 0,
                    'large_baggage' : this.step_third.large_baggage ? 1 : 0,
                    'payment' : parseInt(this.step_fourth.payment, 10) || 0,
                    'selected_way_option' : this.selected_way_option,
                    'car_id' : this.selected_offer.db_id,
                    'data_destination_from_lat_lng' : JSON.stringify(this.data_destination_from_lat_lng),
                    'data_destination_to_lat_lng' : JSON.stringify(this.data_destination_to_lat_lng),
                };
                return result;
            }
        }
    }
</script>

<style>

    .form-field-error{
        display: none;
    }

    .form-field--error .form-field-error{
        display: block;
        color: red;
        font-size: 12px;
        font-weight: bold;
        text-transform: uppercase;
        margin-top: 5px;
    }

    .form-field--error input {
        outline: 1px solid red;
    }

    .pac-container{
        z-index: 99999999;
    }

    .componentLoading{
        position: relative;
    }

    .componentLoading:after{
        content: "";
        left: 0px;
        right: 0px;
        top: 0px;
        bottom: 0px;
        background-color: rgba(255,255,255,0.7);
        background-image: url("../../../../../images/images_frontend/loading.gif");
        position: absolute;
        background-position: 50% 20%;
        background-repeat: no-repeat;
        pointer-events: none;
    }

    .fakeForm{
        visibility: hidden;
    }

</style>